import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import {
  englishIqDemoV2Schema,
  englishIqItemV2Schema,
  englishIqProgressV2Schema,
} from '../schemasV2';

export const answerEnglishIqV2DataSchema = z.object({
  completionReady: z.boolean(),
  demoPreload: englishIqDemoV2Schema.nullable().optional(),
  item: englishIqItemV2Schema.nullable(),
  progress: englishIqProgressV2Schema,
  replaced: z.boolean(),
  token: z.string().min(1),
});

export type IAnswerEnglishIqV2Data = z.infer<typeof answerEnglishIqV2DataSchema>;

export const answerEnglishIqV2ResponseSchema: z.ZodSchema<IAPI<IAnswerEnglishIqV2Data>> =
  createApiResponseSchema(answerEnglishIqV2DataSchema) as z.ZodSchema<IAPI<IAnswerEnglishIqV2Data>>;

export type IAnswerEnglishIqV2Response = IAPI<IAnswerEnglishIqV2Data>;
